import {useMeStore} from '@progyny/store/meStore'

declare global {
  interface Window {
    heap: any
  }
}

export function useHeap() {
  const user = useMeStore((s) => s.user)
  const isTestCompany = useMeStore((s) => s.isTestCompany)
  const companyName = useMeStore((s) => s.companyName)
  const countryCode = useMeStore((s) => s.countryCode)

  const userProperties = {
    Role: user?.isManager ? 'Manager' : 'Member',
    Company: companyName,
    Country: countryCode,
    Eligibility: user?.member.isAspiring ? 'Aspiring' : 'Eligible',
    IsTestCompany: isTestCompany,
    CurrentLanguage: user?.member.language,
    BrowserLanguage: window.navigator.language,
  }

  function sendHeapData() {
    const heap = window.heap
    return setTimeout(() => {
      if (heap) {
        try {
          heap.identify(user?.member.id)
          heap.addUserProperties(userProperties)
        } catch (error) {
          console.error('[Member Portal] - Heap error!', error)
        }
      }
    }, 1000)
  }

  const trackHeapEvent = (
    eventName: string,
    eventProperties?: {[key: string]: unknown}
  ): void => {
    const heap = window.heap
    const propsKeys = Object.keys(eventProperties || {})

    // This comes from heap docs.
    const restrictedNames = [
      'click',
      'change',
      'pageview',
      'submit',
      'event',
      'pgClick',
      'pgChange',
      'pgPageview',
      'pgSubmit',
      'pgEvent',
    ]
    if (restrictedNames.includes(eventName)) {
      throw new Error(
        `Heap Analytics: ${restrictedNames.join(',')} are restricted words. Be more specific to the case.`
      )
    }

    // Better to enforce 1 style of events & props naming.
    if (
      !/^pg([A-Z][a-z0-9]*)*$/.test(eventName) ||
      propsKeys.some((s) => !/^pg([A-Z][a-z0-9]*)*$/.test(s))
    ) {
      throw new Error(
        'Heap Analytics: Prefix event name and properties with "pg", and use camelCase casing style.'
      )
    }

    // Basic infos will be sent in every usage.
    const basicInfo = {
      pgUserAgent: window.navigator.userAgent,
      pgBrowserLanguage: window.navigator.language,
      pgPageUrl: window.location.href,
      ...userProperties,
    }

    try {
      if (heap && typeof heap.track === 'function') {
        heap.track(eventName, {...basicInfo, ...eventProperties})
      }
    } catch (error) {
      console.error(error)
    }
  }

  return {sendHeapData, trackHeapEvent}
}
